import { Button } from '@/components/ui/button';
import { useBuildVersion } from '@/lib/buildVersion';
import { RefreshCw, X } from 'lucide-react';
import { useEffect, useState } from 'react';

// 같은 build 식별자에 대해서는 dismiss 를 기억해 다시 노출하지 않는다.
// 새 배포가 또 떨어지면 식별자가 바뀌어 다시 뜬다.
const DISMISS_KEY = 'innermate.newVersionDismissed';

export function NewVersionToast() {
  const { current, newVersionAvailable } = useBuildVersion();
  const [dismissedKey, setDismissedKey] = useState<string | null>(() =>
    typeof window === 'undefined' ? null : sessionStorage.getItem(DISMISS_KEY),
  );

  const buildKey = current ? `${current.builtAt ?? ''}|${current.commit}|${current.version}` : null;

  useEffect(() => {
    // 새 build 가 잡히면 (buildKey 변경) 이전 dismiss 무효화.
    if (buildKey && dismissedKey && dismissedKey !== buildKey) {
      sessionStorage.removeItem(DISMISS_KEY);
      setDismissedKey(null);
    }
  }, [buildKey, dismissedKey]);

  if (!newVersionAvailable || !current) return null;
  if (dismissedKey === buildKey) return null;

  const dismiss = () => {
    if (buildKey) {
      sessionStorage.setItem(DISMISS_KEY, buildKey);
      setDismissedKey(buildKey);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm rounded-lg border border-border bg-surface shadow-lg">
      <div className="flex items-start gap-3 p-4">
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-foreground">새 버전이 배포되었습니다</div>
          <div className="mt-1 text-xs text-foreground-muted">
            새로고침하면 최신 화면으로 전환됩니다. 작성 중인 내용은 잃지 않으려면 먼저 저장해
            주세요.
          </div>
          <div className="mt-3 flex items-center gap-2">
            <Button size="sm" onClick={() => location.reload()}>
              <RefreshCw className="size-3.5" />
              새로고침
            </Button>
            <Button size="sm" variant="ghost" onClick={dismiss}>
              나중에
            </Button>
          </div>
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="text-foreground-muted hover:text-foreground -m-1 p-1"
          aria-label="알림 닫기"
        >
          <X className="size-4" />
        </button>
      </div>
    </div>
  );
}
